import mutations from './siteMutations'
import actions from './siteActions'
import state from './siteState'
import getters from './siteGetters'

export default {
  state,
  actions,
  getters,
  mutations,
}
